export default "__VITE_ASSET__DqA_ITjx__"